import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { ventrisConfig } from '../ventris.config';

import HomeIcon from '../icons/HomeIcon';
import StudentIcon from '../icons/StudentIcon';
import GroupIcon from '../icons/GroupIcon';
import TestIcon from '../icons/TestIcon';
import ProfileIcon from '../icons/ProfileIcon';
import ResultsIcon from '../icons/ResultsIcon';
import ClinicianIcon from '../icons/ClinicianIcon';
import DirectoryIcon from '../icons/DirectoryIcon';
import SchoolStudentIcon from '../icons/SchoolStudentIcon';
import TeacherIcon from '../icons/TeacherIcon';
import { getUseCaseTerminology } from '../useCase';
import { userHasResultsAccess } from '../assessmentAccess';

import logo from '../assets/img/logo.jpg';

type HeaderProps = {
    portal: string;
    page: string;
};

function Header({ portal, page }: HeaderProps) {
  const [user, setUser] = useState(() => JSON.parse(sessionStorage.getItem("current_user") || "{}") as any);
  const [showProfile, setShowProfile] = useState(false);
  const terms = getUseCaseTerminology();
  const administratorName = user?.administrator_name || "Ventris Learning";
  const administratorEmail = user?.administrator_email || "support@ventrislearning.com";
  const showResults = userHasResultsAccess(user);

  useEffect(() => {
    let currentUser = sessionStorage.getItem("current_user");
    setUser(JSON.parse(currentUser!));
  }, []);

  const logout = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/logout', {
        method: 'post',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify({
        user_id: user.id
        })
    }).then(function (response) {
        return response.json();
    }).then(async function (data) {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("portal");
        sessionStorage.removeItem("current_user");
        document.location.href = "/";
    });
  }

  return (
    <>
        <header>
          <Navbar as="div" expand="lg" fixed="top" sticky="top" className="ventris-navbar">
            <Container className="no-padding">
                <Navbar.Brand as={Link} to="/" aria-current={portal === "admin" && page === "home" ? "page" : undefined} className="ventris-brand-link">
                    <img src={logo} alt="Ventris Learning" className="ventris-header-logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" className="ventris-nav-collapse">
                    <Nav as="nav" aria-label="Primary" className="me-auto ventris-nav">
                        {portal === "admin" ?
                        <>
                            <Link to="/organizations" aria-current={page === "organizations" ? "page" : undefined} className={page === "organizations" ? "header-button-selected header-button-selected-organizations" : "header-button"}>
                                <DirectoryIcon /> {terms.directory}
                            </Link>
                            <Link to="/classes" aria-current={page === "classes" ? "page" : undefined} className={page === "classes" ? "header-button-selected header-button-selected-classes" : "header-button"}>
                                <GroupIcon /> {terms.classes}
                            </Link>
                            <Link to="/users" aria-current={page === "users" ? "page" : undefined} className={page === "users" ? "header-button-selected header-button-selected-users" : "header-button"}>
                                {terms.useCase === "SLP" ? <ClinicianIcon /> : <TeacherIcon />} {terms.managedUsers}
                            </Link>
                            <Link to="/students" aria-current={page === "students" ? "page" : undefined} className={page === "students" ? "header-button-selected header-button-selected-students" : "header-button"}>
                                {terms.useCase === "School" ? <SchoolStudentIcon /> : <StudentIcon />} {terms.students}
                            </Link>
                            <Link to="/tests" aria-current={page === "tests" ? "page" : undefined} className={page === "tests" ? "header-button-selected header-button-selected-tests" : "header-button"}>
                                <TestIcon /> Tests
                            </Link>
                            {showResults ? <Link to="/results" aria-current={page === "results" ? "page" : undefined} className={page === "results" ? "header-button-selected header-button-selected-results" : "header-button"}>
                                <ResultsIcon /> Results
                            </Link> : null}
                            <button type="button" onClick={() => setShowProfile(true)} className={showProfile ? "header-button-selected header-button-selected-profile" : "header-button"} aria-controls="profile-flyover" aria-expanded={showProfile}>
                                <ProfileIcon /> Profile
                            </button>
                        </> :
                        <>
                            <Link to="/" aria-current={page === "home" ? "page" : undefined} className={page === "home" ? "header-button-selected header-button-selected-home" : "header-button"}>
                                <HomeIcon /> Home
                            </Link>
                            <Link to="/students" aria-current={page === "students" ? "page" : undefined} className={page === "students" ? "header-button-selected header-button-selected-students" : "header-button"}>
                                {terms.useCase === "School" ? <SchoolStudentIcon /> : <StudentIcon />} {terms.students}
                            </Link>
                            <Link to="/classes" aria-current={page === "classes" ? "page" : undefined} className={page === "classes" ? "header-button-selected header-button-selected-classes" : "header-button"}>
                                <GroupIcon /> {terms.classes}
                            </Link>
                            <Link to="/groups" aria-current={page === "groups" ? "page" : undefined} className={page === "groups" ? "header-button-selected header-button-selected-groups" : "header-button"}>
                                <GroupIcon /> Groups
                            </Link>
                            <Link to="/tests" aria-current={page === "tests" ? "page" : undefined} className={page === "tests" ? "header-button-selected header-button-selected-tests" : "header-button"}>
                                <TestIcon /> Tests
                            </Link>
                            {showResults ? <Link to="/results" aria-current={page === "results" ? "page" : undefined} className={page === "results" ? "header-button-selected header-button-selected-results" : "header-button"}>
                                <ResultsIcon /> Results
                            </Link> : null}
                            <button type="button" onClick={() => setShowProfile(true)} className={showProfile ? "header-button-selected header-button-selected-profile" : "header-button"} aria-controls="profile-flyover" aria-expanded={showProfile}>
                                <ProfileIcon /> Profile
                            </button>
                        </> }
                    </Nav>
                </Navbar.Collapse>
            </Container>
          </Navbar>
        </header>
        <Offcanvas id="profile-flyover" show={showProfile} onHide={() => setShowProfile(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="profile-flyover-title">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title id="profile-flyover-title">Profile</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
                <h4>Personal Info</h4>
                <Form.Group className="mb-3 ventris-form-element" controlId="profile-first-name">
                    <Form.Label>First Name:</Form.Label>
                    <Form.Control required type="text" autoComplete="given-name" placeholder="First Name" value={user.first_name} />
                    <Form.Control.Feedback type="invalid">Please enter a first name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3 ventris-form-element" controlId="profile-last-name">
                    <Form.Label>Last Name:</Form.Label>
                    <Form.Control required type="text" autoComplete="family-name" placeholder="Last Name" value={user.last_name} />
                    <Form.Control.Feedback type="invalid">Please enter a last name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3 ventris-form-element" controlId="profile-email">
                    <Form.Label>Email Address:</Form.Label>
                    <Form.Control required type="email" autoComplete="email" placeholder="Email Address" value={user.email} />
                    <Form.Control.Feedback type="invalid">Please enter a valid email address.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3 ventris-form-element" controlId="profile-role">
                    <Form.Label>My Role:</Form.Label>
                    <Form.Select required aria-label="Role" value={user.role}>
                        <option value="Clinician">{terms.teacher}</option>
                        <option value="Admin">Admin</option>
                    </Form.Select>
                </Form.Group>
                <br />
                <Button variant="primary" className="ventris-button-primary ventris-button-primary-black full-width" onClick={logout}>Save Changes</Button>
                <br />
                <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-black full-width" onClick={logout}>Logout</Button>
                <br /><br />
                <h4>Administrator Info</h4>
                Please contact your administrator to make any organization or {terms.class.toLowerCase()} changes.
                <br /><br />
                <strong>Name:</strong>
                <br />
                {administratorName}
                <br /><br />
                <strong>Email Address:</strong>
                <br />
                <a href={`mailto:${administratorEmail}`} className="ventris-link">{administratorEmail}</a>
                <br /><br />
            </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Header;
